import { IconButton, Tooltip } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useScriptMode } from "../../contexts/ScriptModeContext";
import { cls } from "../hatim/soft/SoftKit";
import { goalSummaryLines, goalValueText } from "./goalRules";

/**
 * Hedef satırı (mobil Hedef Detayları gibi): ad, "Genel" / "Özel" rozeti,
 * altında takip özeti (birim · biçim, günler, plan), sağda günlük değer.
 * onEdit / onDelete verilmezse satır kilitli görünür.
 */
export default function GoalListRow({ goal, badge, onEdit, onDelete, busy = false }) {
  const { t } = useScriptMode();
  const lines = goalSummaryLines(goal, t);
  const locked = !onEdit && !onDelete;
  return (
    <li className={`flex items-center gap-3 px-4 py-3 ${cls.row}`} data-goal={goal.label}>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 min-w-0">
          <span className={`text-base truncate ${cls.title}`}>{goal.label}</span>
          {badge ? (
            <span
              className={`shrink-0 text-[11px] px-2 py-0.5 rounded-full ${
                badge.tone === "custom" ? cls.chip : "bg-terakkiSurfaceAlt text-terakkiNeutral dark:bg-white/[0.06] dark:text-white/70"
              }`}
            >
              {badge.label}
            </span>
          ) : null}
        </div>
        {lines.map((line) => (
          <div key={line} className={`text-xs mt-0.5 truncate ${cls.muted}`}>
            {line}
          </div>
        ))}
      </div>
      <span className={`text-sm shrink-0 ${cls.accent}`}>{goalValueText(goal, t)}</span>
      {locked ? (
        <Tooltip title={t("my_goals_locked")}>
          <LockOutlinedIcon fontSize="small" className={cls.faint} aria-label={t("my_goals_locked")} />
        </Tooltip>
      ) : (
        <div className="flex items-center shrink-0">
          {onEdit ? (
            <IconButton size="small" onClick={onEdit} disabled={busy} aria-label={`${t("edit")} ${goal.label}`}>
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
          ) : null}
          {onDelete ? (
            <IconButton
              size="small"
              onClick={onDelete}
              disabled={busy}
              aria-label={`${t("delete")} ${goal.label}`}
              className={cls.danger}
            >
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          ) : null}
        </div>
      )}
    </li>
  );
}
